import React from 'react';
import {useSelector} from 'react-redux';
import {DiaryRootState} from 'appRoot/rootReducer';
import AdminService from 'external-services/diary-admin-service/admin.service';
import {accountActions} from 'app/reducers/account/slice';

import {errorStateActions, getAccordionDetail} from 'app/reducers/errorState/slice';
import {CONTACT_MSG} from 'appRoot/app-error-messages';
import VenueSelector from 'external-components/venue-selector';
import {useAppDispatch} from 'appRoot/Store';
import {IVenueSelectorProps} from 'external-components/venue-selector/types';
import {IAllAccountsResponse} from 'external-services/diary-admin-service/types';
import {rootDisplayActions} from 'app/reducers/display/slice';
import LoginActions from 'app/actions/login.actions';

const NS = 'VenueSelectorList';

export default function VenueSelectorList() {
  const dispatch = useAppDispatch();

  const account = useSelector((state: DiaryRootState) => state.accountReducer.account);
  const allAccountsForUser = useSelector(
    (state: DiaryRootState) => state.accountReducer.allAccountsForUser
  );
  const quantity = useSelector((state: DiaryRootState) => state.accountReducer.quantity);
  const searchString = useSelector((state: DiaryRootState) => state.accountReducer.searchString);
  const isAdminUser = useSelector((state: DiaryRootState) => state.accountReducer.isAdminUser);
  const isSwitchVenue = useSelector((state: DiaryRootState) => state.venueReducer.isSwitchVenue);

  const venueHandler = async (id: number, accountId?: any) => {
    // have to tweak here to make account has venue info when login as admin user
    // even we can get all account info from previous request, but we cannot use at here, as different request return different account details
    if (accountId) {
      await AdminService.loadAccount(accountId).then((account) => {
        return AdminService.getVenuesInfo(account, accountId, true);
      })
    }
    AdminService.loadVenue(id.toString()).then(function () {
      dispatch(rootDisplayActions.setShowNewVenueSelector(false)) // To make sure it doesnt render again once logged out - Should only render after logged in
      isSwitchVenue ? LoginActions.switchVenue() : LoginActions.openApp()
    }).catch(function (err) {
      console.log('Error while Loading Venue')
      dispatch(
        errorStateActions.setErrorState({
          errorTitle: 'Problem while loading venue',
          errorMessage: `Sorry, there was a problem while loading the venue. \n\n${CONTACT_MSG}`,
          accordionDetail: getAccordionDetail(err),
        })
      );
    });

  };

  const handleSearchAccounts = async (searchValue: string) => {
    try {
      const searchedAccounts = await AdminService.getAllAccounts(0, searchValue);
      dispatch(accountActions.setAccountSearchString(searchValue));
      dispatch(accountActions.setAllAccountsForUser(searchedAccounts.data));
      dispatch(accountActions.setAccountsQuantity(searchedAccounts.quantity));
    } catch (e) {
      dispatch(
        errorStateActions.setErrorState({
          errorTitle: 'Problem searching accounts',
          errorMessage: `Sorry, there was a problem searching for that account. \n\n${CONTACT_MSG}`,
          accordionDetail: getAccordionDetail(e),
        })
      );
    }
  };

  const handleLoadMore = async (
    accountCounter: number,
    searchAccounts: string
  ): Promise<IAllAccountsResponse> => {
    try {
      const loadMoreAccountsInfo = await AdminService.getAllAccounts(
        accountCounter,
        searchAccounts
      );
      dispatch(
        accountActions.setAllAccountsForUser([...allAccountsForUser, ...loadMoreAccountsInfo.data])
      );
      dispatch(accountActions.setAccountsQuantity(loadMoreAccountsInfo.quantity));
      return loadMoreAccountsInfo;
    } catch (e) {
      dispatch(
        errorStateActions.setErrorState({
          errorTitle: 'Problem loading more accounts',
          errorMessage: `Sorry, there was a problem searching for more accounts. \n\n${CONTACT_MSG}`,
          accordionDetail: getAccordionDetail(e),
        })
      );
      return null;
    }
  };

  const logoutVenue = () => {
    // dispatch(logout({ isLegacyLogin, skipReload: true }));
    LoginActions.logout()
  };

  const handleCancel = () => {
    const venueId = AdminService.getVenue()?.id;
    if (venueId) {
      venueHandler(venueId);
    }
  };

  const ownProps: IVenueSelectorProps = {
    isSwitchVenue,
    searchString,
    quantity,
    isAdminUser,
    allAccountsForUser,
    account,
    hideLogout: true,
    venueHandler: (id, accountId) => venueHandler(id, accountId),
    handleLoadMore: (accountCounter: number, searchAccounts: string) =>
      handleLoadMore(accountCounter, searchAccounts),
    logoutVenue: () => logoutVenue(),
    cancelHandler: () => handleCancel(),
    handleSearchAccounts: (searchValue) => handleSearchAccounts(searchValue),
  };

  return <VenueSelector {...ownProps} />;
}
